import { createSelector } from '@ngrx/store';
import * as fromReducer from '../reducers/portal-roles.reducer';

export const getPortalRolesEntities = createSelector(
  fromReducer.getPortalRoleFeatureState,
  (state) => (state ? state.entities : {}),
);

export const getPortalRoles = createSelector(
  getPortalRolesEntities,
  (entities) => Object.keys(entities).map((id) => entities[id]),
);

export const getPortalRolesLoaded = createSelector(
  fromReducer.getPortalRoleFeatureState,
  fromReducer.getPortalRolesLoaded,
);

export const getPortalRolesLoading = createSelector(
  fromReducer.getPortalRoleFeatureState,
  fromReducer.getPortalRolesLoading,
);
